import { useState, useRef, useEffect, Suspense } from "react";
import { ComingEvents } from "./ComingEvents";
import { Blogs } from "./Blog";
import { useSearchParams, useRouter } from "next/navigation";
import { MotionDiv } from "@/components/ui/MotionDiv";

type Category = "Évènements à venir" | "Blog";

const BlogEventsContent = () => {
  const gridRef = useRef<HTMLElement>(null);
  const [selectedCategory, setSelectedCategory] =
    useState<Category>("Évènements à venir");
  const searchParams = useSearchParams();
  const router = useRouter();

  useEffect(() => {
    const category = searchParams.get("category");
    if (category === "blog") {
      setSelectedCategory("Blog");
    } else if (category === "events") {
      setSelectedCategory("Évènements à venir");
    }
  }, [searchParams]);

  const handleCategoryChange = (category: Category) => {
    setSelectedCategory(category);
    const newCategory = category === "Blog" ? "blog" : "events";
    router.push(`/blog-evenements?category=${newCategory}`);
  };

  return (
    <section
      ref={gridRef}
      className="flex flex-col gap-12 px-4 py-20 ph:px-24 md:px-48 lg:px-72 xl:px-96"
    >
      <nav className="flex flex-wrap justify-start gap-12 text-lg">
        {["Évènements à venir", "Blog"].map((category) => (
          <div key={category} className="flex justify-start">
            <button
              onClick={() => handleCategoryChange(category as Category)}
              className="relative inline-block pb-1"
            >
              <span
                className={`${
                  selectedCategory === category
                    ? "font-medium text-white"
                    : "text-white hover:text-white"
                } relative whitespace-nowrap transition-colors`}
              >
                {category.toUpperCase()}
                {selectedCategory === category && (
                  <MotionDiv
                    className="absolute -bottom-[3px] left-0 h-0.5 w-full bg-gradient-to-r from-[#F9F383] via-[#F14553] to-[#19477E]"
                    initial={{ scaleX: 0 }}
                    animate={{ scaleX: 1 }}
                    transition={{
                      duration: 0.4,
                      ease: "easeOut",
                    }}
                  />
                )}
              </span>
            </button>
          </div>
        ))}
      </nav>

      {selectedCategory === "Évènements à venir" ? (
        <ComingEvents />
      ) : (
        <Blogs gridRef={gridRef} />
      )}
    </section>
  );
};

export const BlogEventsGrid = () => {
  return (
    <Suspense fallback={<div>Chargement...</div>}>
      <BlogEventsContent />
    </Suspense>
  );
};
